<app-modal-generico [modelo]="modalGenerico">
  <article class="row bg-gray">
    <section class="col-8">
      <form
        class="col-12 m-auto form"
        [formGroup]="formDatos"
        (ngSubmit)="confirm()"
      >
        <div class="form-row mb-3">
          <div class="col-6 form-group">
            <label class="small text-secondary required" for="estado"
              >Estado</label
            >
            <select
              id="estado"
              formControlName="estado_posterior_id"
              class="form-control"
              [(ngModel)]="selectedStatusId"
              (change)="setSelectedStatus(selectedStatusId)"
            >
              <option [ngValue]="null" selected="true">Seleccione</option>
              <ng-container *ngFor="let item of estados">
                <option [ngValue]="item.estado_solicitud_id">
                  {{ item.descripcion }}
                </option>
              </ng-container>
            </select>
          </div>
          <div class="col-6 form-group" *ngIf="devuelto">
            <label class="small text-secondary required" for="estado"
              >Motivo de devolución</label
            >
            <mat-select class="form-control form-control-sm" id="categoria" placeholder="Seleccione"
                formControlName="motivo_devolucion_id" multiple disableOptionCentering>
                <mat-option *ngFor="let item of motivo" id="i" [value]="item.motivo_devolucion_id">
                  {{ item.descripcion  }}
                </mat-option>
            </mat-select>
          </div>
          <div class="col-12 form-group m-auto">
            <label class="small text-secondary required mt-2" for="comentario"
              >Observaciones</label
            >
            <textarea
              id="comentario"
              formControlName="observaciones"
              class="form-control"
              rows="6"
              type="text"
            ></textarea>
          </div>
          <div class="col form-group text-center">
            <button
              type="submit"
              [disabled]="!formDatos.valid"
              class="btn btn-primary paso-capacidad w-100 mt-3"
            >
              Enviar
            </button>
          </div>
        </div>
      </form>
    </section>
    <section class="col-4">
      <div #texto class="texto"></div>
    </section>
  </article>
</app-modal-generico>
